/* PDP gallery — fullscreen lightbox z zoom.
 * Klik na zdjęcie → overlay fullscreen z tym zdjęciem
 * Klik na zdjęcie w overlay → toggle zoom 1x/2.4x (pan drag gdy zoomed)
 * ← → strzałki, ESC → close, klik outside → close
 * Swipe left/right na mobile → prev/next
 */
(function () {
	var gallery = document.querySelector('.pdp-gallery[data-pdp-zoom-src]');
	if (!gallery) return;

	var fullSrcs = [];
	try { fullSrcs = JSON.parse(gallery.getAttribute('data-pdp-zoom-src')) || []; } catch (e) {}
	if (!fullSrcs.length) return;

	var targets = gallery.querySelectorAll('[data-pdp-zoom-target]');
	if (!targets.length) return;

	// ── Build overlay lazy on first click ──
	var overlay = null;
	var imgEl = null;
	var counterEl = null;
	var current = 0;
	var zoomed = false;
	var panX = 0, panY = 0;
	var dragStartX = 0, dragStartY = 0;
	var isDragging = false;
	var didDrag = false;

	function build() {
		overlay = document.createElement('div');
		overlay.className = 'kb-lightbox';
		overlay.setAttribute('role', 'dialog');
		overlay.setAttribute('aria-modal', 'true');
		overlay.setAttribute('aria-label', 'Podgląd zdjęcia');
		overlay.innerHTML =
			'<button type="button" class="kb-lightbox-close" aria-label="Zamknij">' +
				'<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M6 6l12 12M18 6L6 18"/></svg>' +
			'</button>' +
			(fullSrcs.length > 1 ?
				'<button type="button" class="kb-lightbox-nav kb-lightbox-prev" aria-label="Poprzednie zdjęcie">' +
					'<svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"><path d="M15 6l-6 6 6 6"/></svg>' +
				'</button>' +
				'<button type="button" class="kb-lightbox-nav kb-lightbox-next" aria-label="Następne zdjęcie">' +
					'<svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"><path d="M9 6l6 6-6 6"/></svg>' +
				'</button>' +
				'<div class="kb-lightbox-counter"></div>'
			: '') +
			'<div class="kb-lightbox-stage"><img class="kb-lightbox-img" alt=""/></div>';
		document.body.appendChild(overlay);
		imgEl = overlay.querySelector('.kb-lightbox-img');
		counterEl = overlay.querySelector('.kb-lightbox-counter');

		overlay.querySelector('.kb-lightbox-close').addEventListener('click', close);
		overlay.addEventListener('click', function (e) {
			if (e.target === overlay || e.target.classList.contains('kb-lightbox-stage')) close();
		});
		var prev = overlay.querySelector('.kb-lightbox-prev');
		var next = overlay.querySelector('.kb-lightbox-next');
		if (prev) prev.addEventListener('click', function (e) { e.stopPropagation(); navigate(-1); });
		if (next) next.addEventListener('click', function (e) { e.stopPropagation(); navigate(1); });

		// Toggle zoom on img click — ale nie po realnym drag (kursor się ruszył >5px).
		imgEl.addEventListener('click', function (e) {
			e.stopPropagation();
			if (didDrag) { didDrag = false; return; }
			toggleZoom(e);
		});

		// Pan gdy zoomed
		imgEl.addEventListener('mousedown', function (e) {
			if (!zoomed) return;
			e.preventDefault();
			dragStartX = e.clientX - panX;
			dragStartY = e.clientY - panY;
			isDragging = true;
			didDrag = false;
			imgEl.style.cursor = 'grabbing';
		});
		document.addEventListener('mousemove', function (e) {
			if (!isDragging) return;
			var nextX = e.clientX - dragStartX;
			var nextY = e.clientY - dragStartY;
			// Threshold 5px — subtle jitter myszy przy klik nie triggeruje "drag" flow.
			if (!didDrag && (Math.abs(nextX - panX) > 5 || Math.abs(nextY - panY) > 5)) didDrag = true;
			panX = nextX;
			panY = nextY;
			applyTransform();
		});
		document.addEventListener('mouseup', function () {
			if (!isDragging) return;
			isDragging = false;
			imgEl.style.cursor = zoomed ? 'zoom-out' : 'zoom-in';
		});

		// Touch swipe (mobile)
		var touchStartX = 0, touchStartY = 0;
		imgEl.addEventListener('touchstart', function (e) {
			if (zoomed || e.touches.length !== 1) return;
			touchStartX = e.touches[0].clientX;
			touchStartY = e.touches[0].clientY;
		}, { passive: true });
		imgEl.addEventListener('touchend', function (e) {
			if (zoomed) return;
			var t = e.changedTouches[0];
			var dx = t.clientX - touchStartX;
			var dy = t.clientY - touchStartY;
			if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy)) navigate(dx < 0 ? 1 : -1);
		}, { passive: true });
	}

	function applyTransform() {
		if (!imgEl) return;
		var scale = zoomed ? 2.4 : 1;
		imgEl.style.transform = 'translate(' + panX + 'px, ' + panY + 'px) scale(' + scale + ')';
	}

	function toggleZoom(e) {
		zoomed = !zoomed;
		if (!zoomed) { panX = 0; panY = 0; }
		imgEl.style.cursor = zoomed ? 'zoom-out' : 'zoom-in';
		imgEl.classList.toggle('is-zoomed', zoomed);
		applyTransform();
	}

	function updateCounter() {
		if (counterEl) counterEl.textContent = (current + 1) + ' / ' + fullSrcs.length;
	}

	function show(index) {
		current = ((index % fullSrcs.length) + fullSrcs.length) % fullSrcs.length;
		zoomed = false; panX = 0; panY = 0;
		imgEl.classList.remove('is-zoomed');
		imgEl.style.cursor = 'zoom-in';
		imgEl.src = fullSrcs[current];
		applyTransform();
		updateCounter();
	}

	function navigate(delta) {
		show(current + delta);
	}

	function open(index) {
		if (!overlay) build();
		show(index);
		overlay.classList.add('is-open');
		document.body.style.overflow = 'hidden';
		document.addEventListener('keydown', onKey);
	}

	function close() {
		if (!overlay) return;
		overlay.classList.remove('is-open');
		document.body.style.overflow = '';
		document.removeEventListener('keydown', onKey);
	}

	function onKey(e) {
		if (e.key === 'Escape') close();
		else if (e.key === 'ArrowRight') navigate(1);
		else if (e.key === 'ArrowLeft') navigate(-1);
	}

	// Bind opening to gallery tiles
	Array.prototype.forEach.call(targets, function (tile, idx) {
		tile.addEventListener('click', function () { open(idx); });
	});
})();
